import React from 'react';

import { css, cx } from '@emotion/css';
import { useFormContext } from 'react-hook-form';

import { Icons } from '@/assets/icons.ts';
import { useStyles } from '@/hooks/useStyles.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { MessageData } from '@/uiKit/molecules/chat/MessageDataSchema.ts';

export type MessageBoxFileUploadProps = {
  className?: string;
};

export const MessageBoxFileUpload: React.FC<MessageBoxFileUploadProps> = ({
  className,
}) => {
  const styles = useStyles(makeStyles);
  const fileInputRef = React.useRef<HTMLInputElement>(null);
  const formContext = useFormContext<MessageData>();

  return (
    <div className={cx(styles.container, className)}>
      {/* Hidden file input, replaced by another button below */}
      <input
        multiple
        type="file"
        id="message-attachment-input"
        value={[]}
        ref={fileInputRef}
        className={styles.fileInput}
        accept={acceptedMimes}
        onChange={e => {
          const files = e.target.files;
          if (!files) {
            return;
          }
          formContext.setValue('contentAttachment', Array.from(files), {
            shouldValidate: true,
          });
        }}
      />
      {/* Visible file input button */}
      <div className={styles.uploadButtonContainer}>
        <Icons.fileUpload
          className={styles.uploadButton}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            fileInputRef.current?.click();
          }}
        />
      </div>
    </div>
  );
};

const acceptedMimes = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/bmp',
  'image/webp',
  'image/svg+xml',
  'text/plain',
  'text/html',
  'text/csv',
  'text/calendar',
  'text/markdown',
  'audio/mpeg',
  'video/mp4',
  'application/zip',
].join(', ');

const makeStyles = (theme: Theme) => ({
  container: css({}),
  fileInput: css({
    display: 'none',
  }),
  uploadButton: css`
    fill: ${theme.palette.text.primary};
    cursor: pointer;
  `,
  uploadButtonContainer: css`
    padding-left: ${theme.spacing(8)};
  `,
});
